import { NazorgDto } from "@/shared/types";

export type Nazorg = {
    betrokkenTreinen: string[];
};

export const Nazorg = {
    fromDto: (dto: NazorgDto): Nazorg => ({
        betrokkenTreinen: dto.betrokkenTreinen,
    }),
};
